import { styled } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button, ButtonLabel } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

export const SELECTION_COLUMN_WIDTH = 58;

export const StyledConnectSalesloftButton = styled(Button)`
    min-width: auto;
    padding: 0;
    gap: 4px;
    border-radius: 6px;

    &:hover,
    &:active {
        background-color: transparent;
    }

    ${ButtonLabel} {
        ${setFontVariant("body2", colorsPalettes.blue[400])};
        flex-grow: 0;
    }

    &:hover ${ButtonLabel}, &:active ${ButtonLabel} {
        color: ${colorsPalettes.blue[400]};
        text-decoration: underline;
    }

    &:focus-visible {
        outline: 1px solid ${colorsPalettes.carbon[500]};
        outline-offset: 2px;
    }
`;

export const StyledTableCardWrapper = styled(Stack)`
    col.ant-table-selection-col,
    .ant-table-selection-col,
    th.ant-table-selection-column,
    td.ant-table-selection-column {
        width: ${SELECTION_COLUMN_WIDTH}px !important;
        min-width: ${SELECTION_COLUMN_WIDTH}px !important;
        max-width: ${SELECTION_COLUMN_WIDTH}px !important;
    }

    [data-automation="table-top-selection-checkbox"] {
        padding-left: 0;

        .ant-checkbox-wrapper {
            margin-left: -12px;
            margin-right: 12px;
            width: ${SELECTION_COLUMN_WIDTH}px;
            height: 56px;
            justify-content: center;
        }
    }
`;
